import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { AnnouncementType } from "../model/Announcement";

export const AnnouncementTypeListApiService = async (): Promise<
  AnnouncementType[]
> => {
  const url = "/announcement_types/";
  const { data } = await axios.get(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useAnnouncementTypeListApiService = () =>
  useQuery<Promise<AnnouncementType[]>, AxiosError, AnnouncementType[]>(
    ["AnnouncementTypeListApiService"],
    () => AnnouncementTypeListApiService()
  );

export default useAnnouncementTypeListApiService;
